import TaskGroupProgressView from './TaskGroupProgressViewContainer';
export default TaskGroupProgressView;
